export default __webpack_public_path__ + "static/media/cat_vaarschool.48eea814.svg";